/** Default placeholder shown when any &lt;img&gt; fails to load (e.g. broken/expired S3 URL). */
export const DEFAULT_IMAGE_PLACEHOLDER =
  '/assets/images/image-placeholder.svg';

/** Marker attribute so the global handler does not re-apply the fallback in a loop. */
export const IMAGE_FALLBACK_APPLIED_ATTR = 'data-cp-img-fallback';
